import { cn } from '@/shared/utils/cn';

/**
 * Sigla de la institución aliada sobre la imagen, en su azul institucional.
 * Es texto, no el logosímbolo: por eso no lleva caja blanca ni zona de
 * seguridad. El manual de UNIMINUTO exige la sigla en mayúscula sostenida,
 * así que el consumidor debe pasarla ya en mayúsculas.
 */
export function CourseCardAllianceTag({
  label,
  className,
}: {
  label: string;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex h-6 w-fit max-w-full items-center rounded-lg bg-(--course-alliance) px-3',
        'text-[0.64rem] font-bold uppercase leading-tight tracking-wide text-white',
        className,
      )}
    >
      {label}
    </span>
  );
}
